/** @format */

import { useContext, useEffect, useState } from 'react';

import { Route, Routes } from 'react-router';

import { Age, CreateAge, EditAge } from '../Components/Base/Age';
import { CreateLevel, EditLevel, Level } from '../Components/Base/Level';
import {
  CreateMatchStyle,
  EditMatchStyle,
  MatchStyle,
} from '../Components/Base/MatchStyle';
import { CreatePost, EditPost, Post } from '../Components/Base/Post';
import Dashboard from '../Components/Dashboard/Dashboard';
import { ShowFactor } from '../Components/Financial';
import Failed from '../Components/Financial/Failed';
import Success from '../Components/Financial/Success';
import Wallet from '../Components/Financial/Wallet';
import WalletHistory from '../Components/Financial/WalletHistory';
import { Event, Home } from '../Components/Home';
import {
  CreateMatch,
  EditMatch,
  Match,
  ShowMatch,
  RegisterList,
} from '../Components/Match/Match';
import Register from '../Components/Match/Match/Register';
import RegisterAllowProvince from '../Components/Match/Match/RegisterAllowProvince';
import RegisterPostAllowProvince from '../Components/Match/Match/RegisterPostAllowProvince';
import { MyMatches, MyPayments, Profile } from '../Components/Profile';
import {
  CreateTicket,
  MyTickets,
  TicketDetail,
  TicketInbox,
} from '../Components/Ticket';
import { MatchReport } from '../Components/Report/Match';
import {
  Transaction,
  TransactionFactor,
} from '../Components/Report/Transaction';
import {
  ClubList,
  CreateClub,
  EditClub,
  MyClubs,
} from '../Components/Club';
import { CreateRole, EditRole, Role } from '../Components/User/Role';
import { EditUser, User } from '../Components/User/User';
import UserRole from '../Components/User/User/UserRole';
import PaymentSettings from '../Components/Admin/PaymentSettings';
import { EventContext } from '../Contexts/EventContext';
import Error404 from '../Shared/Components/Errors/Error404';
import Loading from '../Shared/Components/Loading';
import { error } from '../Shared/Components/Toast';
import useApi from '../Shared/hooks/api/Index';
import { useAccess } from '../Shared/hooks/useAccess';

const ProtectedRoutes = () => {
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(false);
  const {
    canManageBaseData,
    canManageRoles,
    canManageUsers,
    canManagePaymentSettings,
    canListClubs,
    canManageMatches,
    canViewFinancialReports,
    canViewMatchReports,
    canManageTickets,
  } = useAccess();

  useEffect(() => {
    const getUser = async () => {
      setLoading(true);
      await useApi.get(
        '/user',
        {},
        (res) => {
          eventContext.authUser = res.data.data;
          eventContext.authRoles = res.data.data.roles ?? [];
          eventContext.userPermissions = res?.data?.data?.permissions ?? [];
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
        },
      );
    };
    getUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? (
    <Loading />
  ) : (
    <>
      <Routes>
        <Route exact path='/panel' element={<Dashboard />} />

        <>
          {canManageBaseData() && (
            <>
              <Route exact path='/panel/base-define/post' element={<Post />} />
              <Route
                exact
                path='/panel/base-define/post/create'
                element={<CreatePost />}
              />
              <Route
                exact
                path='/panel/base-define/post/edit/:id'
                element={<EditPost />}
              />
              <Route exact path='/panel/base-define/age' element={<Age />} />
              <Route
                exact
                path='/panel/base-define/age/create'
                element={<CreateAge />}
              />
              <Route
                exact
                path='/panel/base-define/age/edit/:id'
                element={<EditAge />}
              />
              <Route
                exact
                path='/panel/base-define/match-level'
                element={<Level />}
              />
              <Route
                exact
                path='/panel/base-define/match-level/create'
                element={<CreateLevel />}
              />
              <Route
                exact
                path='/panel/base-define/match-level/edit/:id'
                element={<EditLevel />}
              />
              <Route
                exact
                path='/panel/base-define/match-style'
                element={<MatchStyle />}
              />
              <Route
                exact
                path='/panel/base-define/match-style/create'
                element={<CreateMatchStyle />}
              />
              <Route
                exact
                path='/panel/base-define/match-style/edit/:id'
                element={<EditMatchStyle />}
              />
            </>
          )}
        </>

        <>
          {canManageRoles() && (
            <>
              <Route exact path='/panel/admin/roles' element={<Role />} />
              <Route
                exact
                path='/panel/admin/roles/create'
                element={<CreateRole />}
              />
              <Route
                exact
                path='/panel/admin/roles/edit/:id'
                element={<EditRole />}
              />
            </>
          )}
        </>
        {canManageUsers() && (
          <>
            <Route exact path='/panel/admin/users' element={<User />} />
            <Route
              exact
              path='/panel/admin/users/edit/:id'
              element={<EditUser />}
            />
            <Route
              exact
              path='/panel/admin/users/set-roles/:id'
              element={<UserRole />}
            />
          </>
        )}
        {canManagePaymentSettings() && (
          <Route
            exact
            path='/panel/admin/payment-settings'
            element={<PaymentSettings />}
          />
        )}

        <Route exact path='/panel/clubs/my' element={<MyClubs />} />
        <Route exact path='/panel/clubs/create' element={<CreateClub />} />
        <Route exact path='/panel/clubs/edit/:id' element={<EditClub />} />
        {canListClubs() && (
          <Route exact path='/panel/clubs' element={<ClubList />} />
        )}

        <Route exact path='/panel/profile' element={<Profile />} />

        <Route
          exact
          path='/panel/profile/match-registered'
          element={<MyMatches />}
        />

        <Route
          exact
          path='/panel/profile/my-payments'
          element={<MyPayments />}
        />

        <Route exact path='/panel/tickets' element={<MyTickets />} />
        <Route exact path='/panel/tickets/create' element={<CreateTicket />} />
        {canManageTickets() && (
          <Route exact path='/panel/tickets/inbox' element={<TicketInbox />} />
        )}
        <Route exact path='/panel/tickets/:id' element={<TicketDetail />} />

        <>
          {canManageMatches() && (
            <>
              <Route exact path='/panel/matches/lists' element={<Match />} />
              <Route
                exact
                path='/panel/matches/:id/register-list'
                element={<RegisterList />}
              />
              <Route
                exact
                path='/panel/matches/create'
                element={<CreateMatch />}
              />
              <Route
                exact
                path='/panel/matches/edit/:id'
                element={<EditMatch />}
              />
              <Route exact path='/panel/matches/:id' element={<ShowMatch />} />
              <Route
                exact
                path='/panel/matches/:id/register-match'
                element={<Register />}
              />
              <Route
                exact
                path='/panel/matches/register-match/match-allowed-province/:id'
                element={<RegisterAllowProvince />}
              />
              <Route
                exact
                path='/panel/matches/register-match-posts/:id'
                element={<RegisterPostAllowProvince />}
              />
            </>
          )}
        </>

        <Route
          exact
          path='/panel/matches/financial-management/show/:id'
          element={<ShowFactor />}
        />
        <Route
          exact
          path='/panel/matches/financial-management/increase-wallet'
          element={<Wallet />}
        />
        <Route
          exact
          path='/panel/matches/financial-management/wallet-history'
          element={<WalletHistory />}
        />

        <Route
          exact
          path='/panel/matches/financial-management/success'
          element={<Success />}
        />

        <Route
          exact
          path='/panel/matches/financial-management/failed'
          element={<Failed />}
        />

        <>
          {canViewFinancialReports() && (
            <>
              <Route
                exact
                path='/panel/reports/all-payments'
                element={<Transaction />}
              />
              <Route
                exact
                path='/panel/reports/payment-factor/:id/payment/:payment_id'
                element={<TransactionFactor />}
              />
            </>
          )}
          {canViewMatchReports() && (
            <Route
              exact
              path='/panel/reports/match-lists'
              element={<MatchReport />}
            />
          )}
        </>

        <Route exact path='/' element={<Home />} />
        <Route exact path='/match/:slug' element={<Event />} />
        <Route path='*' element={<Error404 />} />
      </Routes>
    </>
  );
};

export default ProtectedRoutes;
